export default __webpack_public_path__ + "static/media/td.6db1069d.png";